module.exports = __webpack_public_path__ + "static/media/landing-1.74ee8643.jpg";